import echarts from 'echarts'
export default{
"gain_price": {
    tooltip: {
      formatter:function(params,ticket, callback){
        return '日期:'+ params.seriesName+'-' +params.name+'<br />价格指数：'+params.value+'  ' ;
      }
  },
  grid: {
      left: '4.5%',
      right: '5%',
      bottom: '3%',
      containLabel: true
  },
    legend: {
        left:'4.5%',
  data: ['2021', '2022', '2023']},
  xAxis: {
      type: 'category',
      boundaryGap: false, //坐标轴两边留白
      data: 
      ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      axisLabel: { //坐标轴刻度标签的相关设置。
          interval: 0, //设置为 1，表示『隔一个标签显示一个标签』
               //marginLeft:15,
          textStyle: {
              color: '#1B253A',
              fontStyle: 'normal',
              fontFamily: '微软雅黑',
              fontSize: 11,
          },
           rotate:30,
      },
      axisTick: { //坐标轴刻度相关设置。
          show: false,
      },
      axisLine: { //坐标轴轴线相关设置
          lineStyle: {
              color: '#E5E9ED',
              // opacity:0.2
          }
      },
      splitLine: { //坐标轴在 grid 区域中的分隔线。
          show: true,
          lineStyle: {
              color: '#E5E9ED',
              // 	opacity:0.1
          }
      }
  },
  yAxis: [{
      type: 'value',
      axisLabel: {
          show: false
      },
      axisLine: {
          show: false
      },
      axisTick: {
          show: false
      },
      splitLine: {
          show: false
      }
  }],
  series: [{
      name: '2021',
      type: 'line',
      //symbol:'none',
      smooth:true,
      itemStyle: {
          normal: {
              color: '#84bf96',
              lineStyle: {
                  color: "#84bf96",
                  width: 1,
                   type:'dotted' ,
                   cap:'square'
              } ,
                areaStyle: {
                  color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                      offset: 0,
                      color: 'rgba(132,191,150,0)'
                  }, {
                      offset: 1,
                      color: 'rgba(132,191,150,0.35)'
                  }]),
              }
          }
      },
      data:[]// [22, 23, 33, 44, 46, 49, 34, 32, 45, 25, 35, 12]
  },
  {
      name: '2022',
      type: 'line',
      //symbol:'none',
      smooth:true,
      itemStyle: {
          normal: {
            label:{
                show:false,
                position:'top',
                textStyle:{
                    fontSize:12,
                    color:'#faa755'
                },
                formatter: function(value){
                    return  value.data +'';
                }
            },
              color: '#faa755',
              lineStyle: {
                  color: "#faa755",
                  type:'dotted' ,
                  width: 1
              } ,
                areaStyle: {
                  color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                      offset: 0,
                      color: 'rgba(250,167,85,0)'
                  }, {
                      offset: 1,
                      color: 'rgba(250,167,85,0.35)'
                  }]),
              }
          }
        
      },
      data:[]// [33, 44, 66, 44, 46, 49, 34, 32, 45, 25, 35, 44]
  },
  {
      name: '2023',
      symbolSize:5,



      type: 'line',
      itemStyle: {
          normal: {
              label:{
                  show:true,
                  position:'top',
                  textStyle:{
                      fontSize:12,
                      color:'#3A84FF'
                  },
                  formatter: function(value){
                    return  value.data+' ';
                }
              },
              color: '#3A84FF',
              lineStyle: {
                  color: "#3A84FF",
                  width: 2
              } 
              
          }
      },
      data: []
  }
  
  ]
},
"gain_discount": {
    tooltip: {
      formatter:function(params,ticket, callback){
         // alert(JSON.stringify(params));
          return '日期:'+ params.seriesName+'-' +params.name+'<br />优惠指数：'+params.value+'  ' ;
      }
  },
  grid: {
      left: '4.5%',
      right: '5%',
      bottom: '3%',
      containLabel: true
  },
    legend: {
        left:'4.5%',
  data: ['2021', '2022', '2023']},
  xAxis: {
      type: 'category',
      boundaryGap: false, //坐标轴两边留白
      data: 
      ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      axisLabel: { //坐标轴刻度标签的相关设置。
          interval: 0, //设置为 1，表示『隔一个标签显示一个标签』
               //marginLeft:15,
          textStyle: {
              color: '#1B253A',
              fontStyle: 'normal',
              fontFamily: '微软雅黑',
              fontSize: 11,
          },
           rotate:30,
      },
      axisTick: { //坐标轴刻度相关设置。
          show: false,
      },
      axisLine: { //坐标轴轴线相关设置
          lineStyle: {
              color: '#E5E9ED',
              // opacity:0.2
          }
      },
      splitLine: { //坐标轴在 grid 区域中的分隔线。
          show: true,
          lineStyle: {
              color: '#E5E9ED',
              // 	opacity:0.1
          }
      }
  },
  yAxis: [{
      type: 'value',
      axisLabel: {
          show: false
      },
      axisLine: {
          show: false
      },
      axisTick: {
          show: false
      },
      splitLine: {
          show: false
      }
  }],
  series: [{
      name: '2021',
      type: 'line',
      //symbol:'none',
      smooth:true,
      itemStyle: {
          normal: {
              color: '#84bf96',
              lineStyle: {
                  color: "#84bf96",
                  width: 1,
                   type:'dotted' ,
                   cap:'square'
              } ,
                areaStyle: {
                  color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                      offset: 0,
                      color: 'rgba(132,191,150,0)'
                  }, {
                      offset: 1,
                      color: 'rgba(132,191,150,0.35)'
                  }]),
              }
          }
      },
      data:[]// [22, 23, 33, 44, 46, 49, 34, 32, 45, 25, 35, 12]
  },
  {
      name: '2022',
      type: 'line',
      //symbol:'none',
      smooth:true,
      itemStyle: {
          normal: {
            label:{
                show:false,
                position:'top',
                textStyle:{
                    fontSize:12,
                    color:'#faa755'
                },
                formatter: function(value){
                    return  value.data +'';
                }
            },
              color: '#faa755',
              lineStyle: {
                  color: "#faa755",
                  type:'dotted' ,
                  width: 1
              } ,
                areaStyle: {
                  color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                      offset: 0,
                      color: 'rgba(250,167,85,0)'
                  }, {
                      offset: 1,
                      color: 'rgba(250,167,85,0.35)'
                  }]),
              }
          }
        
      },
      data:[]// [33, 44, 66, 44, 46, 49, 34, 32, 45, 25, 35, 44]
  },
  {
      name: '2023',
      symbolSize:5,



      type: 'line',
      itemStyle: {
          normal: {
              label:{
                  show:true,
                  position:'top',
                  textStyle:{
                      fontSize:12,
                      color:'#3A84FF'
                  },
                  formatter: function(value){
                    return  value.data+'';
                }
              },
              color: '#3A84FF',
              lineStyle: {
                  color: "#3A84FF",
                  width: 2
              } 
              
          }
      },
      data: []
  }
  
  ]
},
}